// define key of public/env-config.js in here

export enum ENV {
    BASE_URL = 'BASE_URL',
    API_MARKET_URL = 'API_MARKET_URL',
    IS_FAKE_SOCKET_MARKET = 'IS_FAKE_SOCKET_MARKET',
    REMOTE_URL = 'REMOTE_URL',
    SOCKET_NOTIFICATION_TIME_WAIT = 'SOCKET_NOTIFICATION_TIME_WAIT'
}